import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, checking } = useAuth();
  const location = useLocation();

  if (checking) {
    return <main className="auth-state" data-testid="auth-checking-state"><div className="shell"><p>Checking your account…</p></div></main>;
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/insights" replace state={{ accessDenied: true }} />;
  return children;
}
